import { type ResourceBundle } from "../core/language";

const bundles: ResourceBundle[] = [];
bundles.push({
    lang: 'en',
    namespace: 'common',
    resources: {
        "charsLeft": "{{rest}} Chars left",
        "minLength": "Min length: {{min}} chars",
        "maxLength": "Max length: {{max}} chars",
        "action": {
            "ok": "OK",
            "cancel": "Cancel",
            "apply": "Apply",
            "delete": "Delete",
            "remove": "Remove",
            "stop": "Stop",
            "append": "Append",
            "add": "Add",
            "selectDate": "Select date"
        },
        "alert": {
            "notice": "Notice",
            "notify": "Notify",
            "error": "Error",
            "warning": "Warning",
            "success": "Success"
        },
        "error": {
            "request": {
                "404": {
                    "title": "Error",
                    "message": "The content could not be loaded due to an error."
                }
            },
            "general": {
                "title": "Error",
                "message": "An unknown error occurred during processing."
            }
        },
        "login": {
            "required": "To access the requested page you must log in. Please enter your login data."
        },
        "showPassword": "Show password",
        "hidePassword": "Hide password",
        "passwordStrength": "Password strength",
        "passwordStrengthEvaluation": {
            "worst": "Worst",
            "bad": "Bad",
            "weak": "Weak",
            "good": "Good",
            "strong": "Strong"
        },
        "mimeTypes": {
            "application": "Application specific",
            "application/pdf": "PDF Document",
            "application/msword": "MS Word Document",
            "application/msexcel": "MS Excel Document",
            "application/mspowerpoint": "MS Powerpoint",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "MS Word Document",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "MS Excel Document",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation": "MS Powerpoint",
            "application/vnd.oasis.opendocument.text": "Open Dokument Text",
            "application/vnd.oasis.opendocument.spreadsheet": "Open Dokument Tabellenkalkulation",
            "application/vnd.oasis.opendocument.presentation": "Open Dokument Präsentation",
            "application/vnd.oasis.opendocument.chart": "Open Dokument Chart",
            "application/vnd.oasis.opendocument.formula": "Open Dokument Formel",
            "image": "Image",
            "image/jpg": "JPG Image",
            "image/jpeg": "JPG Image",
            "image/gif": "GIF Image",
            "image/png": "PNG Image",
            "image/tiff": "TIFF Image",
            "image/bmp": "Bitmap Image",
            "video": "Video",
            "video/mp4": "MP4 Video",
            "video/mpg": "MPG Video",
            "audio": "Audio",
            "audio/wav": "WAV Audio",
            "audio/mp3": "MP3 Audio",
            "audio/ogg": "OGG Audio"
        },
        "validationError": {
            "title": "Formcheck failed",
            "message": "The form contains incomplete or incorrect entries. Please check the red marked fields for correctness."
        },
        "validator": {
            "passwordVerification": {
                "notvalid": "The confirmation password must match the password."
            },
            "selectionRequired": {
                "notvalid": "Please make a selection."
            },
            "equals": {
                "notvalid": "The entered value «{{source}}» does not match «{{dest}}»."
            },
            "notEmpty": {
                "null": "This field must not be empty.",
                "notvalid": "This field must not be empty."
            },
            "string": {
                "notvalid": "A valid string is expected."
            },
            "stringLength": {
                "between": "The length of the given string was not between {{minimum}} and {{maximum}} characters.",
                "less": "The length of the given string is less than {{minimum}} characters.",
                "exceed": "The length of the given string exceeded {{maximum}} characters.",
                "pasteOverflow": "The length of the pasted content exceeded {{maximum}} characters."
            },
            "emailAddress": {
                "notvalid": "The given subject was not a valid email address."
            },
            "integer": {
                "notvalid": "The given subject was not a valid integer."
            },
            "float": {
                "notvalid": "The given subject was not a valid float."
            },
            "boolean": {
                "nottrue": "The given subject was not true.",
                "notfalse": "The given subject was not false."
            },
            "numbersOnly": {
                "notvalid": "The given subject may only contain numbers."
            },
            "numberRange": {
                "notvalid": "The given subject was not a valid number.",
                "range": "The given subject was not in the valid range ({{minimum}} - {{maximum}})."
            },
            "file": {
                "notaccepted": "Only files of the following type are allowed: {{allowed}}.",
                "wrongsize": "The size of the selected file(s) exceeds the allowed size of {{max}}."
            },
            "regularExpression": {
                "empty": "The regular expression was empty.",
                "nomatch": "The given subject did not match the pattern.",
                "error": "The regular expression «{{pattern}}» contained an error."
            },
            "yourInput": "Your input"
        },
        "confirm": {
            "delete": "Do you really want to delete this entry?"
        },
        "consent": {
            "info": "At this point we present content from an external provider. In order for you to see this content, you must agree to the use of cookies.",
            "optoutInfo": "I agree to external content being displayed to me. This may result in personal data being transmitted to third-party platforms. You can revoke this consent at any time in your cookie settings. More about this in our <a href=\"/service/datenschutz\" target=\"_blank\">Privacy policy</a>.",
            "vendor": "Vendor",
            "confirmAction": "Give consent and display content",
            "optoutAction": "Disagree consent and don´t display external content anymore"
        }
    }
});

bundles.push({
    lang: 'en',
    namespace: 'photoswipe',
    resources: {
        "closeTitle": "close",
        "zoomTitle": "zoom",
        "arrowPrevTitle": "back",
        "arrowNextTitle": "next",
        "indexIndicatorSep": " von ",
        "errorMsg": 'A error occured while loading the image.'
    }
});

bundles.push({
    lang: 'en',
    namespace: 'accessibility',
    resources: {
        "info": "Here you can adjust various settings for optimal display and better accessibility.",
        "group": {
            "typeface": "Typeface",
            "colorFilter": "Color filter",
            "theme": "Theme"
        },
        "control": {
            "fontSize": "Font size",
            "grayscale": "Grayscale",
            "blueLightFilter": "Blue light filter",
            "brightness": "Brightness",
            "moreContrast": "More contrast",
            "darkmode": "Dark mode"
        },
        "action": {
            "bigger": "Font size bigger",
            "smaller": "Font size smaller",
            "resetSettings": "Reset settings"
        },
        "sizes": {
            "normal": "Normal",
            "middle": "Middle",
            "max": "Max"
        }
    }
});

export default bundles;
